module.exports = __webpack_public_path__ + "assets/img/banner.d34c90b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pagesInvestment/banner.png
// module id = ag5f
// module chunks = 114